<template>
  <div>
    <Loading v-if="!requested" />
    <TopNavbar :title="'My Orders'" :bgColor="'bg-red'">
      <div class="order-detail-navbar">
        <div class="home-logo"><img :src="homelogo" /></div>
        <div class="title onHome">{{'My Rider'}}</div>
      </div>
    </TopNavbar>
    <div class="cart-index" v-if="requested">
      <DeliveryMap :address="addresss" />
      <div class="footer" style="background: transparent">
        <div class="address">
          <div class="source" style="display: flex; align-items: center; padding: 0 16px;">
            <div>
              <van-icon color="#ee2d24" size="20px" name="shop-o" />
            </div>
            <div style="padding-left: 16px; text-align: left;">{{ merchant.location.address }}</div>
          </div>
          <div style="display: flex; align-items: center; padding: 0 16px;">
            <div style="width: 20px;">
              <div class="dot">.</div>
              <div class="dot">.</div>
            </div>
            <div></div>
          </div>
          <div style="display: flex; align-items: center; padding: 0 16px; margin-top: 8px;">
            <div>
              <van-icon color="#ee2d24" size="20px" name="location-o" />
            </div>
            <div style="padding-left: 16px; text-align: left;">{{ customer.location.address }}</div>
          </div>
        </div>
        <div class="driver" style="margin: 6px;">
          <div class="status-wrapper">
            <van-icon color="#ee2d24" name="info-o" size="20px"/>
            <div class="status-text" v-if="driver.status">{{ driver.status }}</div>
          </div>
          <hr>
          <div class="driver-wrapper">
            <div class="flex justify-between">
              <div>
                <div class="flex flexcenter">
                  <div class="image">
                    <van-icon color="#ee2d24" name="user-o" size="30px" v-if="!driver.thumb"/>
                    <img :src="driver.thumb" v-if="driver.thumb"/>
                  </div>
                  <div style="padding-left: 20px;">
                    <div class="name" v-if="driver.name">{{ driver.name }}</div>
                    <div class="plate">{{ driver.vehicle.plate }}</div>
                  </div>
                </div>
              </div>
              <van-icon color="#ee2d24" v-if="driver.mobile" @click="callDriverPhone" size="30px" name="phone-o" />
            </div>
          </div>
        </div>
        <div class="footer-btn-container">
          <div class="flex flex-center">
            <div class="flex1 view-order" @click="closeAndBack">Order Detail</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from '../../components/common/TopNavbar.vue'
import { Toast } from 'vant';
import TablesInfo from '../../components/common/TablesInfo.vue'
import Loading from '../../components/common/Loading.vue'
import DeliveryMap from '@/components/gmap/delievryDriverMap.vue'
import { getOrderDriverInfo } from '@/api/api'
import homelogo from "@/assets/fastorder.logo.png"
import { cartMixin } from '@/mixins/cartMixin'

export default {
  components: {
    TopNavbar, Loading, DeliveryMap
  },
  props: {
  },
  data() {
    return {
      requested: false,
      homelogo: homelogo,
      orderid: 0,
      merchant: {
        name: '',
        mobile: '',
        location: {
          address: '',
          coordinate: {
            lat: 0,
            lng: 0
          }
        }
      },
      customer: {
        name: '',
        mobile: '',
        location: {
          address: '',
          coordinate: {
            lat: 0,
            lng: 0
          }
        }
      },
      driver: {
        mobile: '',
        name: '',
        thumb: '',
        plate: '',
        vehicle: {
          type: '',
          model: '',
          plate: ''
        },
        location: {
          address: '',
          coordinate: {
            lat: 0,
            lng: 0
          }
        },
        status: '',
      },
      addresss: {
        merchant: {
          // position: { lat: 3.08694539418266, lng: 101.69002262621154 },
          // addr: 'Jalan Kuchai Maju 12 Kuchai Entrepreneurs Park 58200 Kuala Lumpur Federal Territory of Kuala Lumpur, Malaysia'
        },
        customer: {
          // position: { lat: 3.0900415241666535, lng: 101.68751744299163 },
          // addr: 'Dynasty 332-2, Jalan Kuchai Maju 8Kuchai Entrepreneurs Park 58200 Kuala Lumpur, Federal Territory of Kuala Lumpur, Malaysia'
        },
        driver: {
          // position: { lat: 3.0894255128651573, lng: 101.68788758783569 },
          // addr: '42-G, Jalan Kuchai Maju 9 Kuchai Entrepreneurs Park 58200 Kuala Lumpur Federal Territory of Kuala Lumpur, Malaysia'
        }
      }
    }
  },
  created() {
    const queryParams = this.$route.query
    this.orderid = queryParams.orderid
    this.initData()
  },
  computed: {
  },
  mixins: [cartMixin],
  methods: {
    callDriverPhone() {
      if (this.driver.mobile) {
        window.location.href = `tel://${this.driver.mobile}`
      }
    },
    closeAndBack() {
      // window.history.back(-1)
      const url = { path: `/order?i=2&mode=2&append=1&c=entry&do=orderdetail&m=weisrc_dish&op=viewdetail&orderid=${this.orderid}&h5api=on&year=2020&pt=wx2h5` }
      this.$router.push(url)
    },
    initData() {
      let queryParams = {
        i: 2,
        c: 'entry',
        do: 'delivery_orderdetail',
        m: 'weisrc_dish',
        orderid: parseInt(this.orderid),
        append: 1,
      }
      getOrderDriverInfo('/app/index.php', queryParams).then(res => {
        if (res.status && res.code == 200) {
          console.log('res>>>', res);
          this.addresss = res.data.addressList || {}
          this.isRefresh = res.data.isRefresh

          console.log('this.addresss>>>', this.addresss);
          
          this.merchant = this.addresss['merchant'];
          this.customer = this.addresss['customer'];
          this.driver = this.addresss['driver'];
        } else {
          this.$toast(res.msg);
        }
        this.requested = true
        this.refreshData()
      }).catch((error) => {
        this.requested = true
      })
    },
    refreshData(){
      if(this.requested && this.isRefresh){
        setTimeout(() => {
          this.initData()
        }, 15000);
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

hr {
  margin: 0 10px;
  border-color: #ee2d24;
}
.title {
  font-weight: 700;
}
.order-detail-navbar {
  width: 100%;
  display: flex;
  align-items: center;
  .home-logo {
    width: 20px;
    height: 20px;
    img {
      width: 100%;
    }
  }
}
.onHome {
  padding: 4px 0;
  flex: 1;
  text-align: center;
}
.cart-index {
  margin-top: 40px;
}
.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: @size14;
  text-align: center;
  box-shadow: 0px 17px 20px 10px rgba(146, 146, 146, 0.85),
    -10px 10px 10px 10px rgba(255, 255, 255, 0.5);
  .flexcenter {
    align-items: center;
  }
  .driver {
    padding: 20px 0 0px 0;
    background-color: #fff;
    color: #000;
    border-radius: 6px;
    
    .status-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 20px;
      margin-bottom: 16px;

      .status-text {
        text-align: left;
        padding-left: 20px;
        font-weight: bolder;
      }
    }

    .driver-wrapper {
      text-align: left;
      margin-top: 5px;
      padding: 10px 20px;
      padding-left: 16px;
      padding-bottom: 16px;

      .name {
        font-weight: bolder;
      }
    }
  }

  .footer-btn-container {
    .view-order {
      background-color: @red;
      padding: 13px 0;
      text-align: center;
      font-weight: bold;
      color: #fff;
    }
  }

  .address {
    margin: 6px; 
    padding: 20px 0; 
    background-color: #fff;
    border-radius: 6px;
  }

  .dot {
    line-height: 6px;
    align-items: center;
    display: flex;
    justify-content: center;
    color: #ee2d24;
  }

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
}
</style>

